import { type RoomDto } from "@crowdcoursing/api/openapi";
import { createSelector } from "@reduxjs/toolkit";

import { type NullSanitized } from "~utils/sanitizeDto";

import { useSelector } from "./useTypedRedux";

const selectPodAndUserId = createSelector(
  [(state) => state.app.selectedPod, (state) => state.user?.id],
  (pod, userId) => ({ pod, userId }),
);

export const useIsFacilitator = (): boolean => {
  const { userId, pod } = useSelector(selectPodAndUserId);

  if (!pod || !userId) {
    return false;
  }

  return userId === pod?.ownerId || (pod?.facilitatorIds?.includes(userId) ?? false);
};

/**
 * Get various information about `state.app.selectedPod`
 * TODO: replace me with graphql
 */
export const usePod = (): Pick<NullSanitized<RoomDto>, "id" | "ownerId"> | undefined =>
  useSelector((state) => {
    const sp = state.app.selectedPod;
    return sp && { id: sp.id, ownerId: sp.ownerId };
  });
